/**
 * Pageview beacon — only runs after analytics consent.
 * Sends path, referrer, and persistent visitor_id (cookie-backed).
 */
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { getOrCreateVisitorId, hasAnalyticsConsent } from '../consent'

function sendPageview(path) {
  if (!hasAnalyticsConsent()) return

  const body = JSON.stringify({
    path,
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    visitor_id: getOrCreateVisitorId(),
    consent: 'analytics',
  })
  const url = '/api/t'
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' })
      if (navigator.sendBeacon(url, blob)) return
    }
  } catch {
    // fall through
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'omit',
  }).catch(() => {})
}

export default function AnalyticsBeacon() {
  const location = useLocation()
  const lastPath = useRef('')

  useEffect(() => {
    const track = () => {
      if (!hasAnalyticsConsent()) {
        lastPath.current = ''
        return
      }
      if ((location.pathname || '').startsWith('/admin')) {
        return
      }
      const pathKey = `${location.pathname}${location.search || ''}`
      if (pathKey === lastPath.current) return
      lastPath.current = pathKey
      sendPageview(location.pathname || '/')
    }

    track()
    window.addEventListener('st:consent', track)
    return () => window.removeEventListener('st:consent', track)
  }, [location.pathname, location.search])

  return null
}
